/**
 * RestartConfiguratorButton.jsx
 *
 * Renamed from legacy "Restart tool finder" to "Restart configurator" per
 * brainstorm wishlist #13. Wipes all DSC selections + toggle state, returns
 * the page to its initial empty state.
 *
 * Citations (port-first):
 *  - Legacy LWC `searchResults.js:1199-1204` `handleRestartConfigurator()` —
 *    invokes the imperative reset (`this.dscSearchData = []`, clears every
 *    `this.selected*` variable, hides the PLP). PWA equivalent is the
 *    `DSC_ACTIONS.RESTART` action handled in `dscCascade.js#reduceRestart`,
 *    invoked via `useDSC().restart()`.
 *  - Legacy LWC `searchResults.html` line 231: `<button class="...
 *    tf-restart-button" data-label="user-action" onclick={handleRestart
 *    Configurator}>{labels.TFRestartTFLabel}</button>`. Legacy label was
 *    "Restart tool finder" — renamed in PWA per wishlist #13.
 *  - Plan §0 row `RestartConfiguratorButton.jsx`: "Renamed 'Restart
 *    configurator' per brainstorm wishlist #13."
 *
 * @module components/dsc/RestartConfiguratorButton
 * @since 2026-05-20 (Group E SP2 — shared DSC primitives)
 */

import { RotateCcw } from 'lucide-react';
import { useDSC } from '@contexts/DSCContext';

export default function RestartConfiguratorButton({
  label = 'Restart configurator',
  dataTestid = 'restart-configurator-button',
}) {
  const { restart } = useDSC();
  return (
    <button
      type="button"
      onClick={restart}
      data-testid={dataTestid}
      className="inline-flex items-center gap-2 px-4 py-2 border border-carbon-black bg-bg-paper text-carbon-black font-sandvik-text text-sm font-medium hover:bg-n1 focus:outline-none focus:ring-2 focus:ring-electric-blue rounded-none"
    >
      <RotateCcw size={16} aria-hidden="true" />
      {label}
    </button>
  );
}
